import { library } from "@fortawesome/fontawesome-svg-core";

import {
  faAlignCenter,
  faAnalytics,
  faAlignLeft,
  faAlignRight,
  faArrowDown,
  faArrowUp,
  faArrowsV,
  faBookSpells,
  faBookmark,
  faBullseye,
  faCheckCircle,
  faClipboardListCheck,
  faClock,
  faCommentsAlt,
  faCrown,
  faDollarSign,
  faEllipsisH,
  faEllipsisV,
  faExclamationTriangle,
  faExclamationCircle,
  faFileAlt,
  faFileContract,
  faFileInvoice,
  faFileInvoiceDollar,
  faFileMedical,
  faFilePdf,
  faFileWord,
  faFlagAlt,
  faFolder,
  faFolderOpen,
  faGripLines,
  faGripLinesVertical,
  faHeartRate,
  faHome,
  faIndent,
  faInfoCircle,
  faQuestionCircle,
  faLink,
  faListOl,
  faListUl,
  faLock,
  faMagic,
  faMicroscope,
  faNetworkWired,
  faOutdent,
  faPaperPlane,
  faPercent,
  faPlayCircle,
  faPaperclip,
  faSpinner,
  faStickyNote,
  faStopwatch,
  faTags,
  faTasks,
  faThumbsDown,
  faThumbsUp,
  faThumbtack,
  faTimesOctagon,
  faUsers,
  faUsersCrown,
  faUserPlus,
} from "@fortawesome/pro-duotone-svg-icons";

library.add(
  faAlignCenter,
  faAlignLeft,
  faAnalytics,
  faAlignRight,
  faArrowDown,
  faArrowUp,
  faArrowsV,
  faBookSpells,
  faBookmark,
  faBullseye,
  faCheckCircle,
  faClipboardListCheck,
  faClock,
  faCommentsAlt,
  faCrown,
  faDollarSign,
  faEllipsisH,
  faEllipsisV,
  faExclamationTriangle,
  faExclamationCircle,
  faFileAlt,
  faFileContract,
  faFileInvoice,
  faFileInvoiceDollar,
  faFileMedical,
  faFilePdf,
  faFileWord,
  faFlagAlt,
  faFolder,
  faFolderOpen,
  faGripLines,
  faGripLinesVertical,
  faHeartRate,
  faHome,
  faIndent,
  faInfoCircle,
  faQuestionCircle,
  faLink,
  faListOl,
  faListUl,
  faLock,
  faMagic,
  faMicroscope,
  faNetworkWired,
  faOutdent,
  faPaperPlane,
  faPercent,
  faPlayCircle,
  faPaperclip,
  faSpinner,
  faStickyNote,
  faStopwatch,
  faTags,
  faTasks,
  faThumbsDown,
  faThumbsUp,
  faThumbtack,
  faTimesOctagon,
  faUsers,
  faUsersCrown,
  faUserPlus,
);



// WEBPACK FOOTER //
// ./src/fontawesome/duoTone.js